import { Space, Tag, Tooltip } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const STATE_COLORS = {
  connected: "green",
  connecting: "orange",
  disconnected: "red",
  closed: "default",
};

/**
 * Users connected to the robot (all of its peers), as tags coloured by connection state.
 *
 * @param {Array} props.Users - output of aggregateConnectedUsers (hooks/useRobotConnectedUsers)
 * @param {string} [props.CurrentUsername] - the logged-in user's name; their own clients are
 *   marked "(you)"
 */
const RobotConnectedUsers = ({ Users = [], CurrentUsername = null }) => {
  const { t } = useTranslation();
  const controllers = Users.filter((u) => u.role === "controller");
  const others = Users.filter((u) => u.role !== "controller");

  const renderTag = (user) => {
    const peersText = user.peers
      .map((p) => t("teleop.status.peerLine", { peer: p.peer_id, role: p.role ?? "?", state: p.state ?? "?" }))
      .join("\n");
    const isSelf = CurrentUsername != null && user.username === CurrentUsername;
    return (
      <Tooltip key={user.user_client_id} title={<span style={{ whiteSpace: "pre-line" }}>{peersText}</span>}>
        <Tag color={STATE_COLORS[user.state] ?? "default"} style={{ marginInlineEnd: 4 }}>
          {user.user_client_id}
          {isSelf && ` ${t("teleop.status.you")}`}
        </Tag>
      </Tooltip>
    );
  };

  return (
    <div className="status-info connected-users">
      <Space>
        <TeamOutlined />
        {t("teleop.status.users", { n: Users.length })}
        {Users.length === 0 && <span style={{ opacity: 0.6 }}>{t("teleop.status.noUsers")}</span>}
      </Space>
      {controllers.length > 0 && (
        <div>
          <span style={{ opacity: 0.75, marginInlineEnd: 4 }}>{t("teleop.status.controller")}</span>
          {controllers.map(renderTag)}
        </div>
      )}
      {others.length > 0 && (
        <div>
          <span style={{ opacity: 0.75, marginInlineEnd: 4 }}>{t("teleop.status.monitor")}</span>
          {others.map(renderTag)}
        </div>
      )}
    </div>
  );
};

export default RobotConnectedUsers;
